import { sb } from '../supabase.ts';
import { IMGBB_API_KEY } from '../config.ts';

export async function renderAddTeacherPage(app: HTMLElement) {
  app.innerHTML = `
<style>
  .add-wrap { background: #f8f9fa; min-height: 100vh; padding: 40px 0; }
  .form-card { background: #fff; border-radius: 16px; border: 1px solid #e5e7eb; padding: 32px; box-shadow: 0 10px 25px rgba(0,0,0,0.05); max-width: 800px; margin: 0 auto; }
  .form-header { text-align: center; margin-bottom: 30px; }
  .form-header h2 { font-size: 24px; font-weight: 800; color: #1e293b; margin-bottom: 8px; }
  .form-header p { color: #64748b; font-size: 14px; }
  
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  .form-group { display: flex; flex-direction: column; gap: 6px; }
  .form-group.full { grid-column: 1 / -1; }
  .form-group label { font-size: 12px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; }
  .form-group input, .form-group select { padding: 10px 14px; border: 1px solid #d1d5db; border-radius: 10px; font-size: 15px; transition: all 0.2s; }
  .form-group input:focus, .form-group select:focus { outline: none; border-color: var(--primary); box-shadow: 0 0 0 4px rgba(0, 97, 242, 0.1); }
  
  .photo-upload { display: flex; align-items: center; gap: 20px; margin-bottom: 24px; padding: 16px; border: 2px dashed #e2e8f0; border-radius: 12px; background: #f8fafc; }
  .photo-preview-box { width: 80px; height: 80px; background: #fff; border-radius: 50%; border: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: center; overflow: hidden; }
  .photo-preview-box img { width: 100%; height: 100%; object-fit: cover; }
  .upload-btn { background: #fff; border: 1px solid #d1d5db; padding: 8px 16px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; transition: 0.2s; }
  .upload-btn:hover { background: #f1f5f9; }
  
  .actions { margin-top: 32px; display: flex; gap: 12px; }
  .btn-submit { flex: 2; background: var(--primary); color: #fff; border: none; padding: 14px; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: 0.3s; }
  .btn-submit:hover { background: #0052cc; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0, 97, 242, 0.2); }
  .btn-submit:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }
  .btn-reset { flex: 1; background: #fff; border: 1px solid #d1d5db; color: #475569; padding: 14px; border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; }
  
  #msgBox { margin-top: 20px; padding: 12px; border-radius: 10px; font-size: 14px; display: none; }
  #msgBox.success { background: #dcfce7; color: #166534; border: 1px solid #bbf7d0; display: block; }
  #msgBox.error { background: #fee2e2; color: #991b1b; border: 1px solid #fecaca; display: block; }

  @media (max-width: 600px) { .form-grid { grid-template-columns: 1fr; } }
</style>

<div class="add-wrap">
  <div class="container">
    <div class="form-card">
      <div class="form-header">
        <h2>Add New Teacher</h2>
        <p>Register a new faculty member in the institution database.</p>
      </div>

      <div class="photo-upload">
        <div class="photo-preview-box">
          <img id="previewImg" src="https://via.placeholder.com/100?text=Teacher" alt="Preview">
        </div>
        <div>
          <label style="display:block; margin-bottom:4px; font-size:12px; font-weight:700;">Profile Photo</label>
          <button type="button" class="upload-btn" id="uploadBtn">Choose Image</button>
          <input type="file" id="fileInput" style="display:none;" accept="image/*">
          <p style="font-size:11px; color:#64748b; margin-top:4px;">Square ratio recommended.</p>
        </div>
      </div>

      <form id="teacherForm">
        <input type="hidden" id="pp_photo" name="pp_photo">
        
        <div class="form-grid">
          <div class="form-group full">
            <label>Teacher Name (English)</label>
            <input type="text" name="teacher_name_en" required placeholder="Full Name in English">
          </div>
          <div class="form-group">
            <label>Sector / Category</label>
            <select name="sector" required>
              <option value="MPO">MPO</option>
              <option value="NON-MPO">NON-MPO</option>
              <option value="STAFF">STAFF</option>
            </select>
          </div>
          <div class="form-group">
            <label>Designation</label>
            <input type="text" name="designation_en" required placeholder="e.g. Assistant Teacher">
          </div>
          <div class="form-group">
            <label>Mobile Number</label>
            <input type="tel" name="mobile_number_en" required placeholder="01XXXXXXXXX" pattern="[0-9]{11}">
          </div>
          <div class="form-group">
            <label>Email Address</label>
            <input type="email" name="teacher_email_id" required placeholder="email@example.com">
          </div>
          <div class="form-group">
            <label>NID Number</label>
            <input type="text" name="nid_number_en" required placeholder="NID Card Number">
          </div>
          <div class="form-group">
            <label>Join Date</label>
            <input type="date" name="join_date" required>
          </div>
        </div>

        <div id="msgBox"></div>

        <div class="actions">
          <button type="button" class="btn-reset" onclick="history.back()">Cancel</button>
          <button type="submit" class="btn-submit" id="submitBtn">Register Teacher</button>
        </div>
      </form>
    </div>
  </div>
</div>
  `;

  const form = document.getElementById('teacherForm') as HTMLFormElement;
  const fileInput = document.getElementById('fileInput') as HTMLInputElement;
  const uploadBtn = document.getElementById('uploadBtn') as HTMLButtonElement;
  const previewImg = document.getElementById('previewImg') as HTMLImageElement;
  const photoUrlInp = document.getElementById('pp_photo') as HTMLInputElement;
  const msgBox = document.getElementById('msgBox')!;
  const submitBtn = document.getElementById('submitBtn') as HTMLButtonElement;

  uploadBtn.onclick = () => fileInput.click();

  fileInput.onchange = async () => {
    const file = fileInput.files?.[0];
    if (!file) return;

    uploadBtn.textContent = 'Uploading...';
    uploadBtn.disabled = true;

    try {
      const formData = new FormData();
      formData.append('image', file);

      const res = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
        method: 'POST',
        body: formData
      });

      const resData = await res.json();
      if (!resData.success) throw new Error(resData.error?.message || 'Upload failed');

      photoUrlInp.value = resData.data.url;
      previewImg.src = resData.data.url;
      uploadBtn.textContent = 'Change Photo';
    } catch (err: any) {
      alert('Upload Error: ' + err.message);
      uploadBtn.textContent = 'Upload Failed';
    } finally {
      uploadBtn.disabled = false;
    }
  };

  form.onsubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const data = Object.fromEntries(formData);

    submitBtn.textContent = 'Saving...';
    submitBtn.disabled = true;
    msgBox.className = '';
    msgBox.style.display = 'none';

    try {
      const { data: inserted, error } = await sb.from('teacher_database').insert([data]).select('iid').single();
      if (error) throw error;

      msgBox.textContent = `Success! Teacher registered with IID: ${inserted.iid}`;
      msgBox.className = 'success';
      form.reset();
      previewImg.src = 'https://via.placeholder.com/100?text=Teacher';
    } catch (err: any) {
      msgBox.textContent = 'Error: ' + err.message;
      msgBox.className = 'error';
    } finally {
      submitBtn.textContent = 'Register Teacher';
      submitBtn.disabled = false;
    }
  };
}
